import { render, staticRenderFns } from "./RewardCarouselItem.vue?vue&type=template&id=e2c4219e&scoped=true"
import script from "./RewardCarouselItem.vue?vue&type=script&lang=js"
export * from "./RewardCarouselItem.vue?vue&type=script&lang=js"
import style0 from "./RewardCarouselItem.vue?vue&type=style&index=0&id=e2c4219e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c4219e",
  null
  
)

export default component.exports